export { default } from './TableSectionDesktop';
